import { render, staticRenderFns } from "./AlertMailConfiguration.vue?vue&type=template&id=97c14bbe&lang=pug&"
import script from "./AlertMailConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AlertMailConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports